import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ProgressBarService } from './progress-bar.service';

@Component({
    selector: 'app-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit, OnDestroy {
    bufferValue: number;
    mode: 'determinate' | 'indeterminate' | 'buffer' | 'query';
    value: number;
    visible: boolean;



    // Private
    private _unsubscribeAll: Subject<any>;



    /**
        * Constructor
        *
        * @param {FuseProgressBarService} _fuseProgressBarService
        */
    constructor(
        private _ProgressBarService: ProgressBarService
    ) {

        // Set the defaults

        // Set the private defaults
        this._unsubscribeAll = new Subject();

    }


    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */

    ngOnInit(): void {

        // Subscribe to the progress bar service properties

        // Buffer value

        this._ProgressBarService.bufferValue
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((bufferValue) => {
                this.bufferValue = bufferValue;
            });

        // Mode
        this._ProgressBarService.mode
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((mode) => {
                this.mode = mode;
            });

        // Value
        this._ProgressBarService.value
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((value) => {
                this.value = value;
            });

        // Visible
        this._ProgressBarService.visible
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((visible) => {
                this.visible = visible;
            });

    }

    /**
      * On destroy
      */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        //  this._unsubscribeAll.next([]);
        this._unsubscribeAll.complete();
    }

}
